import React from "react";
import { Outlet } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import CustomGlobalLoading from "@/components/GlobalLoading";

const RootLayout = () => {
    return (
        <ScrollToTop>
            <CustomGlobalLoading />
            <Outlet />
        </ScrollToTop>
    );
};

export default RootLayout;
